import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const categoryApiSlice = createApi({
    reducerPath: 'categoryApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/umbraco/api/OnTheCornerApi',
    }),
    endpoints(builder) {
        return {
            getCategories: builder.query({
                async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
                    const result = await fetchWithBQ(`/GetCategories`)
                    return result.data ? { data: result.data as any } : { error: result.error }
                },

            }),
        };
    },
});

export const { useGetCategoriesQuery } = categoryApiSlice; 